import { LinkOutlined } from "@ant-design/icons";
import { Space, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { type LinkedAccess } from "@fitness-app/data-models/entities/ProductClient";

interface OwnProps {
  linkedAccess: LinkedAccess;
  clientEmail: string;
}

/**
 * Where a linked access (TRE-2110) takes its period from: the client's access in
 * another product. Without this the "Okres dostępu" dates look hand-set, and a
 * date changed here is silently moved back by the next sync of the source.
 */
export const LinkedAccessInfo: FunctionComponent<OwnProps> = ({ linkedAccess, clientEmail }) => {
  const { t } = useTranslation("client");

  return (
    <Space direction="vertical" size={4}>
      <Space size={8} wrap>
        <Tag icon={<LinkOutlined />} color={linkedAccess.followSource ? "blue" : "default"}>
          {t(linkedAccess.followSource ? "oneTime.linkedAccess.following" : "oneTime.linkedAccess.frozen")}
        </Tag>
        <Link to={`/products/${linkedAccess.sourceProductId}/clients/${encodeURIComponent(clientEmail)}`}>
          {linkedAccess.sourceProductName}
        </Link>
        <Typography.Text type="secondary">
          {t("oneTime.linkedAccess.linkedAt", { date: dayjs.unix(linkedAccess.linkedAt).format("DD.MM.YYYY") })}
        </Typography.Text>
      </Space>
      <Typography.Text type="secondary">
        {t(linkedAccess.followSource ? "oneTime.linkedAccess.followingHint" : "oneTime.linkedAccess.frozenHint")}
      </Typography.Text>
    </Space>
  );
};
